import { Box } from "@mui/system";

import { useState } from "react";

import {
  Button,
  ButtonBase,
  Radio,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";

import { RestaurantHeader, useWindowDimensions } from "igfd-ui/src";

import Logo from "../../assets/logo.svg";
import { useRestaurantContext } from "../../hooks/useRestaurantContext";

const HEADER_HEIGHT = 290;

interface MenuSelectionPageProps {
  onClose: () => void;
}

export const MenuSelectionPage = ({ onClose }: MenuSelectionPageProps) => {
  const { menuId, brandName, logoImageUrl, menusInDisplayOrder, onMenuSelect } =
    useRestaurantContext();

  const {
    palette: { oscar },
  } = useTheme();

  const [selectedMenuId, setSelectedMenuId] = useState<string>(menuId || "");
  const { height } = useWindowDimensions();
  const contentCentered = height - HEADER_HEIGHT;

  const handleMenuSelect = (menuId: string) => {
    onMenuSelect?.(menuId);
    onClose();
  };

  return (
    <Stack
      flex={1}
      sx={({ palette }) => ({
        backgroundColor: palette.background.paper,
      })}
    >
      <Box marginTop={10} marginBottom={4}>
        <RestaurantHeader brandName={brandName} logoImageUrl={logoImageUrl} />
      </Box>

      <Stack
        display="flex"
        gap={2}
        alignItems="center"
        justifyContent="center"
        height={contentCentered}
      >
        <Typography variant="labelRMedium" align="center">
          Select a Menu
        </Typography>

        <Stack overflow="auto" paddingX={6}>
          {menusInDisplayOrder?.map((menu) => (
            <Stack
              alignItems="center"
              borderBottom={`1px solid ${oscar.light.borders.gray}`}
              direction="row"
              key={menu.menuId}
              gap={1.5}
              paddingY={2}
              minWidth={320}
              sx={{
                cursor: "pointer",
              }}
              onClick={() => setSelectedMenuId(menu.menuId)}
            >
              <Radio
                sx={{
                  "&.MuiRadio-colorPrimary": {
                    color: `${oscar.light.content.link} !important`,
                  },
                  padding: 0,
                }}
                checked={selectedMenuId === menu.menuId}
              />
              <Typography variant="labelRMedium">{menu.menuName}</Typography>
            </Stack>
          ))}
        </Stack>

        <ButtonBase
          disabled={!selectedMenuId}
          sx={{
            backgroundColor: oscar.light.surface.black,
            borderRadius: 4,
            paddingX: 6,
            minHeight: 48,
            marginTop: 4,
          }}
          onClick={() => selectedMenuId && handleMenuSelect?.(selectedMenuId)}
        >
          <Typography color={oscar.light.content.clear} variant="buttonL">
            Done
          </Typography>
        </ButtonBase>
      </Stack>

      <Stack
        position="absolute"
        bgcolor={oscar.light.surface.clear}
        left={0}
        right={0}
        alignItems="center"
        paddingTop={1}
        bottom={40}
      >
        <img src={Logo} alt="Ingredifind" style={{ width: 130 }} />
      </Stack>
    </Stack>
  );
};
